<div class="center_text">
  <h2>{{ 'landing.menu-qr.cta-title' | translate }}</h2>
  <button class="hero_button" type="button" routerLink="/auth/rest-signup">{{ 'landing.menu-qr.create-account' | translate }}</button>
</div>
